import { render, staticRenderFns } from "./goodsOrder-list.vue?vue&type=template&id=fbb3affe&scoped=true&"
import script from "./goodsOrder-list.vue?vue&type=script&lang=js&"
export * from "./goodsOrder-list.vue?vue&type=script&lang=js&"
import style0 from "./goodsOrder-list.vue?vue&type=style&index=0&id=fbb3affe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb3affe",
  null
  
)

export default component.exports